// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__o4g3N","icon":"styles_icon__b_2Xd"};